"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var e = require("react"),
    t = require("@react-pdf-viewer/core");

function n(e) {
  if (e && e.__esModule) return e;
  var t = Object.create(null);
  return e && Object.keys(e).forEach(function (n) {
    if ("default" !== n) {
      var r = Object.getOwnPropertyDescriptor(e, n);
      Object.defineProperty(t, n, r.get ? r : {
        enumerable: !0,
        get: function get() {
          return e[n];
        }
      });
    }
  }), t.default = e, Object.freeze(t);
}

var r = n(e),
    _a = function a() {
  return (_a = Object.assign || function (e) {
    for (var t, n = 1, r = arguments.length; n < r; n++) {
      for (var a in t = arguments[n]) {
        Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
      }
    }

    return e;
  }).apply(this, arguments);
},
    o = function o(e) {
  var n = r.useState(e.get("currentPage") || 0),
      a = n[0],
      o = n[1],
      i = function i(e) {
    o(e);
  };

  return t.useIsomorphicLayoutEffect(function () {
    return e.subscribe("currentPage", i), function () {
      e.unsubscribe("currentPage", i);
    };
  }, []), {
    currentPage: a
  };
},
    i = function i(e) {
  var t = r.useState(e.get("numberOfPages") || 0),
      n = t[0],
      a = t[1],
      o = function o(e) {
    a(e);
  };

  return r.useEffect(function () {
    return e.subscribe("numberOfPages", o), function () {
      e.unsubscribe("numberOfPages", o);
    };
  }, []), {
    numberOfPages: n
  };
},
    u = function u(e) {
  var n = e.store,
      a = r.useContext(t.LocalizationContext),
      u = r.useState("1"),
      c = u[0],
      l = u[1],
      s = o(n).currentPage,
      g = i(n).numberOfPages;
  r.useEffect(function () {
    return l("" + (s + 1));
  }, [s]);

  var f = function f(e) {
    var t = n.get("jumpToPage");
    t && t(e);
  },
      m = a && a.pageNavigation ? a.pageNavigation.enterPageNumber : "Enter a page number";

  return r.createElement("span", {
    className: "rpv-page-navigation__current-page-input"
  }, r.createElement(t.TextBox, {
    ariaLabel: m,
    type: "text",
    value: c,
    onChange: l,
    onKeyDown: function onKeyDown(e) {
      switch (e.key) {
        case "ArrowUp":
          (r = s - 1) >= 0 && (l("" + (r + 1)), f(r));
          break;

        case "ArrowDown":
          (n = s + 1) < g && (l("" + (n + 1)), f(n));
          break;

        case "Enter":
          t = parseInt(c, 10), "" === c || t < 1 || t > g ? l("" + (s + 1)) : f(t - 1);
      }

      var t, n, r;
    }
  }));
},
    c = function c(e) {
  var t = e.children,
      n = e.store;
  return (t || function (e) {
    return r.createElement(r.Fragment, null, e.currentPage + 1);
  })({
    currentPage: o(n).currentPage,
    numberOfPages: i(n).numberOfPages
  });
},
    l = function l() {
  return r.createElement(t.Icon, {
    size: 16
  }, r.createElement("path", {
    d: "M21.783,21.034H2.332c-0.552,0-1-0.448-1-1c0-0.182,0.05-0.361,0.144-0.517L11.2,3.448\n            c0.286-0.472,0.901-0.624,1.373-0.338c0.138,0.084,0.254,0.2,0.338,0.338l9.726,16.069c0.286,0.473,0.134,1.087-0.339,1.373\n            C22.143,20.984,21.965,21.034,21.783,21.034z"
  }));
},
    s = {
  left: 0,
  top: 8
},
    g = function g(e) {
  var n = e.isDisabled,
      a = e.onClick,
      o = r.useContext(t.LocalizationContext),
      i = o && o.pageNavigation ? o.pageNavigation.goToFirstPage : "First page";
  return r.createElement(t.Tooltip, {
    ariaControlsSuffix: "page-navigation-first",
    position: t.Position.BottomCenter,
    target: r.createElement(t.MinimalButton, {
      ariaLabel: i,
      isDisabled: n,
      onClick: a
    }, r.createElement(l, null)),
    content: function content() {
      return i;
    },
    offset: s
  });
},
    f = function f(e) {
  var t = e.children,
      n = e.store;
  return (t || function (e) {
    return r.createElement(g, {
      isDisabled: e.isDisabled,
      onClick: e.onClick
    });
  })({
    isDisabled: 0 === o(n).currentPage,
    onClick: function onClick() {
      var e = n.get("jumpToPage");
      e && e(0);
    }
  });
},
    m = function m(e) {
  var n = e.isDisabled,
      a = e.onClick,
      o = r.useContext(t.LocalizationContext),
      i = o && o.pageNavigation ? o.pageNavigation.goToFirstPage : "First page";
  return r.createElement(t.MenuItem, {
    icon: r.createElement(l, null),
    isDisabled: n,
    onClick: a
  }, i);
},
    p = function p() {
  return r.createElement(t.Icon, {
    size: 16
  }, r.createElement("path", {
    d: "M2.32,2.966h19.452c0.552,0.001,1,0.449,0.999,1.001c0,0.182-0.05,0.36-0.144,0.516L12.9,20.552\n            c-0.286,0.472-0.901,0.624-1.373,0.338c-0.138-0.084-0.254-0.2-0.338-0.338L1.465,4.483C1.179,4.01,1.331,3.396,1.804,3.11\n            C1.96,3.016,2.138,2.966,2.32,2.966z"
  }));
},
    C = {
  left: 0,
  top: 8
},
    b = function b(e) {
  var n = e.isDisabled,
      a = e.onClick,
      o = r.useContext(t.LocalizationContext),
      i = o && o.pageNavigation ? o.pageNavigation.goToLastPage : "Last page";
  return r.createElement(t.Tooltip, {
    ariaControlsSuffix: "page-navigation-last",
    position: t.Position.BottomCenter,
    target: r.createElement(t.MinimalButton, {
      ariaLabel: i,
      isDisabled: n,
      onClick: a
    }, r.createElement(p, null)),
    content: function content() {
      return i;
    },
    offset: C
  });
},
    P = function P(e) {
  var t = e.children,
      n = e.store,
      a = o(n).currentPage,
      u = i(n).numberOfPages;
  return (t || function (e) {
    return r.createElement(b, {
      isDisabled: e.isDisabled,
      onClick: e.onClick
    });
  })({
    isDisabled: a + 1 >= u,
    onClick: function onClick() {
      var e = n.get("jumpToPage");
      e && e(u - 1);
    }
  });
},
    v = function v(e) {
  var n = e.isDisabled,
      a = e.onClick,
      o = r.useContext(t.LocalizationContext),
      i = o && o.pageNavigation ? o.pageNavigation.goToLastPage : "Last page";
  return r.createElement(t.MenuItem, {
    icon: r.createElement(p, null),
    isDisabled: n,
    onClick: a
  }, i);
},
    E = function E() {
  return r.createElement(t.Icon, {
    size: 16
  }, r.createElement("path", {
    d: "M0.541,5.627L11.666,18.2c0.183,0.207,0.499,0.226,0.706,0.043c0.015-0.014,0.03-0.028,0.043-0.043\n            L23.541,5.627"
  }));
},
    d = {
  left: 0,
  top: 8
},
    k = function k(e) {
  var n = e.isDisabled,
      a = e.onClick,
      o = r.useContext(t.LocalizationContext),
      i = o && o.pageNavigation ? o.pageNavigation.goToNextPage : "Next page";
  return r.createElement(t.Tooltip, {
    ariaControlsSuffix: "page-navigation-next",
    position: t.Position.BottomCenter,
    target: r.createElement(t.MinimalButton, {
      ariaLabel: i,
      isDisabled: n,
      onClick: a
    }, r.createElement(E, null)),
    content: function content() {
      return i;
    },
    offset: d
  });
},
    x = function x(e) {
  var t = e.children,
      n = e.store,
      a = o(n).currentPage,
      u = i(n).numberOfPages;
  return (t || function (e) {
    return r.createElement(k, {
      onClick: e.onClick,
      isDisabled: e.isDisabled
    });
  })({
    isDisabled: a + 1 >= u,
    onClick: function onClick() {
      var e = n.get("jumpToPage");
      e && e(a + 1);
    }
  });
},
    D = function D(e) {
  var n = e.isDisabled,
      a = e.onClick,
      o = r.useContext(t.LocalizationContext),
      i = o && o.pageNavigation ? o.pageNavigation.goToNextPage : "Next page";
  return r.createElement(t.MenuItem, {
    icon: r.createElement(E, null),
    isDisabled: n,
    onClick: a
  }, i);
},
    T = function T() {
  return r.createElement(t.Icon, {
    size: 16
  }, r.createElement("path", {
    d: "M23.535,18.373L12.409,5.8c-0.183-0.207-0.499-0.226-0.706-0.043C11.688,5.77,11.674,5.785,11.66,5.8\n            L0.535,18.373"
  }));
},
    L = {
  left: 0,
  top: 8
},
    N = function N(e) {
  var n = e.isDisabled,
      a = e.onClick,
      o = r.useContext(t.LocalizationContext),
      i = o && o.pageNavigation ? o.pageNavigation.goToPreviousPage : "Previous page";
  return r.createElement(t.Tooltip, {
    ariaControlsSuffix: "page-navigation-previous",
    position: t.Position.BottomCenter,
    target: r.createElement(t.MinimalButton, {
      ariaLabel: i,
      isDisabled: n,
      onClick: a
    }, r.createElement(T, null)),
    content: function content() {
      return i;
    },
    offset: L
  });
},
    I = function I(e) {
  var t = e.store,
      n = e.children,
      a = o(t).currentPage;
  return (n || function (e) {
    return r.createElement(N, {
      isDisabled: e.isDisabled,
      onClick: e.onClick
    });
  })({
    isDisabled: a <= 0,
    onClick: function onClick() {
      var e = t.get("jumpToPage");
      e && e(a - 1);
    }
  });
},
    O = function O(e) {
  var n = e.isDisabled,
      a = e.onClick,
      o = r.useContext(t.LocalizationContext),
      i = o && o.pageNavigation ? o.pageNavigation.goToPreviousPage : "Previous page";
  return r.createElement(t.MenuItem, {
    icon: r.createElement(T, null),
    isDisabled: n,
    onClick: a
  }, i);
};
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */


exports.DownArrowIcon = p, exports.NextIcon = E, exports.PreviousIcon = T, exports.UpArrowIcon = l, exports.pageNavigationPlugin = function () {
  var e = r.useMemo(function () {
    return t.createStore();
  }, []),
      n = function n(t) {
    return r.createElement(f, _a({}, t, {
      store: e
    }));
  },
      o = function o(t) {
    return r.createElement(P, _a({}, t, {
      store: e
    }));
  },
      i = function i(t) {
    return r.createElement(x, _a({}, t, {
      store: e
    }));
  },
      l = function l(t) {
    return r.createElement(I, _a({}, t, {
      store: e
    }));
  };

  return {
    install: function install(t) {
      e.update("jumpToPage", t.jumpToPage);
    },
    onDocumentLoad: function onDocumentLoad(t) {
      e.update("numberOfPages", t.doc.numPages);
    },
    onViewerStateChange: function onViewerStateChange(t) {
      return e.update("currentPage", t.pageIndex), t;
    },
    jumpToPage: function jumpToPage(t) {
      var n = e.get("jumpToPage");
      n && n(t);
    },
    CurrentPageInput: function CurrentPageInput() {
      return r.createElement(u, {
        store: e
      });
    },
    CurrentPageLabel: function CurrentPageLabel(t) {
      return r.createElement(c, _a({}, t, {
        store: e
      }));
    },
    GoToFirstPage: n,
    GoToFirstPageButton: function GoToFirstPageButton() {
      return r.createElement(n, null, function (e) {
        return r.createElement(g, _a({}, e));
      });
    },
    GoToFirstPageMenuItem: function GoToFirstPageMenuItem(e) {
      return r.createElement(n, null, function (t) {
        return r.createElement(m, {
          isDisabled: t.isDisabled,
          onClick: function onClick() {
            t.onClick(), e.onClick();
          }
        });
      });
    },
    GoToLastPage: o,
    GoToLastPageButton: function GoToLastPageButton() {
      return r.createElement(o, null, function (e) {
        return r.createElement(b, _a({}, e));
      });
    },
    GoToLastPageMenuItem: function GoToLastPageMenuItem(e) {
      return r.createElement(o, null, function (t) {
        return r.createElement(v, {
          isDisabled: t.isDisabled,
          onClick: function onClick() {
            t.onClick(), e.onClick();
          }
        });
      });
    },
    GoToNextPage: i,
    GoToNextPageButton: function GoToNextPageButton() {
      return r.createElement(i, null, function (e) {
        return r.createElement(k, _a({}, e));
      });
    },
    GoToNextPageMenuItem: function GoToNextPageMenuItem(e) {
      return r.createElement(i, null, function (t) {
        return r.createElement(D, {
          isDisabled: t.isDisabled,
          onClick: function onClick() {
            t.onClick(), e.onClick();
          }
        });
      });
    },
    GoToPreviousPage: l,
    GoToPreviousPageButton: function GoToPreviousPageButton() {
      return r.createElement(l, null, function (e) {
        return r.createElement(N, _a({}, e));
      });
    },
    GoToPreviousPageMenuItem: function GoToPreviousPageMenuItem(e) {
      return r.createElement(l, null, function (t) {
        return r.createElement(O, {
          isDisabled: t.isDisabled,
          onClick: function onClick() {
            t.onClick(), e.onClick();
          }
        });
      });
    }
  };
};